// extracted by mini-css-extract-plugin
export var csatScore = "_kj-5";
export var header = "_kj-1";
export var panelWrapper = "_kj-2";
export var postPreview = "_kj-3";
export var rightContent = "_kj-0";
export var wrappingText = "_kj-4";